import { invoke } from '@shared/easyfy.decorators';
import Splide from '@splidejs/splide';
import { elements as getElements } from '@shared/easyfy.core';
import SliderHelper from '@clientShared/sliderHelper';

@invoke
export class ArticleListComponent {
  static Instance: ArticleListComponent;

  constructor() {
    ArticleListComponent.Instance = this;
  }

  onInit() {
    getElements('[data-container="articlelist-scroll"]').forEach((list) => {
      list.classList.add('splide');

      const result = SliderHelper.CreateSlider(list as HTMLElement | null);
      if (!result) {
        return;
      }
      const { slider, excludePagination } = result;

      SliderHelper.OnPaginationMounted(slider, list as HTMLElement, excludePagination);

      slider.mount();

      SliderHelper.AddSliderOverlay(list as HTMLElement);
      SliderHelper.UpdateImagesSize(list as HTMLElement);
      SliderHelper.PreventLinkMulitplication(slider);
    });
  }
}
